module.exports = __webpack_public_path__ + "img/icon-lock.5a28123c.svg";